import React from 'react';
import { cn } from '../../lib/utils';

interface TrafficItem {
  name: string;
  percentage: number;
  color?: string;
  status?: string;
  id?: string;
}

interface TrafficListProps {
  title: string;
  items: TrafficItem[];
  className?: string;
}

export const TrafficList: React.FC<TrafficListProps> = ({
  title,
  items,
  className
}) => {
  return (
    <div className={cn("bg-card border border-border rounded-xl p-6", className)}>
      <h3 className="text-lg font-semibold text-foreground mb-4">{title}</h3>
      <div className="space-y-4">
        {items.map((item, index) => (
          <div key={item.id || index} className="space-y-2">
            <div className="flex justify-between items-center">
              <div className="flex-1 min-w-0">
                <span className="text-sm font-medium text-foreground truncate block">{item.name}</span>
                {item.status && (
                  <span className="text-xs text-muted-foreground">{item.status}</span>
                )}
              </div>
              <span className="text-sm text-muted-foreground ml-2">{item.percentage}%</span>
            </div>
            <div className="w-full bg-muted rounded-full h-2">
              <div
                className={cn(
                  "h-2 rounded-full transition-all duration-300",
                  item.color || "bg-primary"
                )}
                style={{ width: `${item.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
